import { render, staticRenderFns } from "./AlterarFiscais.vue?vue&type=template&id=5b2374c2&scoped=true"
import script from "./AlterarFiscais.vue?vue&type=script&lang=js"
export * from "./AlterarFiscais.vue?vue&type=script&lang=js"
import style0 from "./AlterarFiscais.vue?vue&type=style&index=0&id=5b2374c2&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b2374c2",
  null
  
)

export default component.exports